export default __webpack_public_path__ + "static/media/Talent_AllSkilledUp.08c60470.png";